import { get, writable } from 'svelte/store';
import { DossierTypesService } from '../../services/dossier-types.service';
export const loading = writable(false);
export const editing = writable(false);
export const filter = writable(null);
export const pagination = writable(null);
export const records = writable([]);
export const record = writable(null);
export const selectedDossierCategory = writable(0);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        filter.set({ criteria: {}, params: null, sorting: "" });
        pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
        records.set([]);
        record.set(null);
        selectedDossierCategory.set(0);
    }
    await loadDossierTypes();
}
export async function loadDossierTypes() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        _filter.criteria.dossierCategoryId = get(selectedDossierCategory);
        let _resp = await DossierTypesService.getDossierTypes(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    let item = {
        oid: 0,
        numCode: 0,
        description: '',
        dossierCategoryId: get(selectedDossierCategory),
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    record.set(Object.assign({}, item.dossierType));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    await DossierTypesService.saveDossierType(_record);
    await loadDossierTypes();
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await DossierTypesService.deleteDossierType(item.oid);
    await loadDossierTypes();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    loadDossierTypes();
}
